import { Component, inject, computed, signal, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { BrandService } from '../../services/brand/brand.service';
import { SessionAuthService } from '../../services/session/session-auth.service';
// import { WalPageService } from '../../services/wal-page.service';
import { DataExchangeService } from '../../services/session/data-exchange.service';
// import { TextResourceService } from '../../services/text-resource.service';
import { AccountTasksComponent } from '../account-tasks/account-tasks.component';
import { PaymentDemoComponent } from '../payment-demo/payment-demo.component';
// import { AppleRecoveryComponent } from '../apple-recovery/apple-recovery.component';
// import { MessagePageComponent } from '../body-sections/message-page/message-page.component';
import { PageContainerComponent } from '../page-container/page-container.component';
import { NotificationPreferencesComponent } from '../notification-preferences/notification-preferences.component';
// import { NotificationHistoryComponent } from '../notification-history/notification-history.component';
import { ErrorPageComponent } from '../error-page/error-page.component';
import { NgComponentOutlet } from '@angular/common';
// import { ExceptionEvent } from '../../classes/exception-event';
import { NGXLogger } from 'ngx-logger';
import { ISessionDetails } from '../../interfaces/session-details';
// import { CustomLoggerService } from '../../services/custom-logger.service';
// import { ISessionDetails } from '../../interfaces/session-details';

// import { TranslateService, TranslateModule, TranslateLoader } from '@ngx-translate/core';
// import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// import { HttpClient } from '@angular/common/http';

// export const translateProvider = {
//   provide: TranslateLoader,
//   useFactory: httpLoaderFactory,
//   deps: [HttpClient]
// };


// export function httpLoaderFactory(http: HttpClient) {
//   console.log('httpLoaderFactory');

// var xx = new TranslateHttpLoader(http, '../../../assets/i18n/', '.json');
// if (xx) {
//   console.log('httpLoaderFactory', xx.getTranslation);
// } else {
//   console.log('httpLoaderFactory', 'in null');
// }

//   return new TranslateHttpLoader(http, '../../../assets/i18n/', '.json');
//   // return new TranslateHttpLoader(http, "http://......", "");
// }

@Component({
    selector: 'app-page-dispatcher',
    standalone: true,
    // imports: [],
    // templateUrl: './page-dispatcher.component.html',
    // styleUrl: './page-dispatcher.component.css'
    template: `
    @if (this.isComponentReady()) {
      <ng-container [ngComponentOutlet]="profileComponent()" />
    } @else {
      <div class="loading-wrapper" role="status" aria-label="Loading">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div> 
    } 
  `,
    styles: [],
    imports: [
        NgComponentOutlet,
    ]
})
export class PageDispatcherComponent  {

  // Reactive computed properties using signals
  isAuthenticated = computed(() => this.dataExchangeService.isAuthenticated());
  hasValidSession = computed(() => this.dataExchangeService.hasValidSession());
  hasBrandInfo = computed(() => this.dataExchangeService.hasBrandInfo());

  profileComponent = computed(() => {
    if (this.isComponentReady()) {
      // console.log('computed source', this.dataExchangeService.source());
      switch (this.dataExchangeService.source()) {
        case 'acct-tsk':
          return AccountTasksComponent;
        // case 'msg-page':
        //   return MessagePageComponent;
        case 'aw-recov':
        case 'ev-page':
        case 'msg-page':
        case 'nm-page':
        case 'notif-log':
        case 'sm-link':
        case 'sub-accts':
        case 'xtr-vi':
          return PageContainerComponent;
        case 'notif-prefs':
          return NotificationPreferencesComponent;
        // case 'notif-log':
        //   return NotificationHistoryComponent;
        case 'pmt-demo':
          return PaymentDemoComponent;
        default:
         this.dataExchangeService.setMessageText('Page Not Found');
          return ErrorPageComponent;
      }
    } else {
      return null;
    }
  }
);

  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly sessionAuthService = inject(SessionAuthService);
  private readonly destroyRef = inject(DestroyRef);
  // private readonly walPageService = inject(WalPageService);
  private readonly brandService = inject(BrandService);
  // private readonly sharedService = inject(SharedService);
  private readonly dataExchangeService = inject(DataExchangeService);
  // private readonly textResourceService = inject( TextResourceService);
  private readonly logger = inject(NGXLogger);
  // private readonly customLogger = inject(CustomLoggerService);

  isComponentReady = signal<boolean>(false);

  isError: boolean = false;

  constructor() {
    // TranslateModule.forChild({
    //   loader: {
    //     provide: TranslateLoader,
    //     useFactory: httpLoaderFactory,
    //     deps: [HttpClient]
    //   },
    // });

  }

  ngOnInit() {
    this.logger.debug('page-dispatcher - entered ngOnInit', new Date().toISOString());
    // Get the parameters from the caller (Walletron)
    this.activatedRoute.queryParamMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        let region: string = params.get('r') || '';
        // console.log('ngOnInit - region', region);
        let sessionId = params.get('si') || '';
        // console.log('ngOnInit - sessionId', sessionId);
        let source = params.get('so') || '';
        if (!(region && source && sessionId)) {
          // need to log this event somehow
          return;
        }
        // console.log('ngOnInit - source', source);
        this.dataExchangeService.setRegion(region);
        this.dataExchangeService.setSource(source);
        this.sessionAuthService.getWalPageSession(region, sessionId)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
        next: () => {

          // Special case when the server returns a new sessionId, so we make a "redirect" to a different page.
          // For example: when we want to display the message page instead of original page
          const session: ISessionDetails = this.dataExchangeService.getSession();          
          if (sessionId != session.walPageUuid) {
            this.logger.log(`PageDispatcherComponent - ngOnInit: origSessionId: ${sessionId}, receivedSessionId: ${session.walPageUuid}`);
            if (session.options) {
              const options: Map<string, string> = new Map(Object.entries(session.options));
              if (options.has('src')) {
                const src: string = options.get('src') || '';
                this.logger.log(`PageDispatcherComponent - ngOnInit: origSource: ${source}, receivedSource: ${src}`);
                if (src) {
                  this.dataExchangeService.setSource(src);            
                }
              }
            }
          }

          let brandCode = this.dataExchangeService.getBrandCode();
          this.getBrandInfo(region, brandCode);
        },
        error: (error) => {
          console.log('pg-disp', error);
        }
      });

      // Get session details
      // this.getTempAuthToken(region, sessionId);
      // Set English as the default language
      // this.textResourceService.setDefaultLang('en');
      // this.textResourceService.setLangs(['en']);
    });

  }

  // public getTempAuthToken(region: string, sessionId: string) {
  //   this.walPageService.getTempAuthToken()
  //     .subscribe({
  //       next: (response) => {
  //         // console.log('getTempAuthToken - response', response);
  //         this.dataExchangeService.setTempToken(response.accessToken);
  //         console.log('getTempAuthToken - accessToken', response.accessToken);
  //         // Get session details
  //         this.getSessionDetails(region, sessionId);
  //       },
  //       error: (error) => {
  //         this.dataExchangeService.setMessageText(error);
  //         this.router.navigate(['/err']);
  //       },
  //       complete: () => {
  //       }
  //     });
  // }

  // public getSessionDetails(region: string, sessionId: string) {
  //   // console.log('getSessionDetails', sessionId);
  //   this.walPageService.getSessionDetails(region, sessionId)
  //   .subscribe({
  //     next: (response) => {
  //       console.log('getSessionDetails- response', response);
  //       this.dataExchangeService.setSession(response);
  //       if (response) {
  //         let sessionDetails: ISessionDetails = response;
  //         // console.log('getSessionDetails sessionDetails', sessionDetails);
  //         // Find out the auth token
  //         if (sessionDetails.options) {
  //           const options: Map<string, string> = new Map(Object.entries(sessionDetails.options));
  //           // console.log('getSessionDetails - options', options);
  //           if (options) {
  //             if (options.has("auth")) {
  //               let authToken: string = options.get('auth') || '';
  //               console.log('getSessionDetails - authToken', authToken);
  //               this.dataExchangeService.setAuthToken(authToken);
  //             }
  //           }
  //         }
  //         let brandCode: string = response.brandCode || '';
  //         this.getBrandInfo(region, brandCode);
  //       }
  //     },
  //     error: (error) => {
  //       // console.log('getSessionDetails error', error);
  //       this.isError = true;
  //       this.dataExchangeService.setMessageText(error);
  //       this.router.navigate(['/err']);
  //     },
  //     complete: () => {
  //     }
  //   });
  // }

  public getBrandInfo(region: string, brandCode: string) {
        this.logger.debug('page-dispatcher - getBrandInfo - before', new Date().toISOString());
    this.brandService.getBrandInfo(region, brandCode, "NPE,WAL_PAGES,EAUTH,CLIENT_TIMEZONE")
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
      next: (response) => {
        // console.log('getBrandInfo - response', response);
        if (response) {
          this.logger.debug('page-dispatcher - getBrandInfo - after', new Date().toISOString());
          this.dataExchangeService.setBrandInfo(response);
          this.isComponentReady.set(true);
          // this.getBrandImage(response.brandLogoImageUrl);

          // Set up languages, if needed
          // let langs = this.sharedService.getBrandConfigProperty(response, '???LANGUAGES???');
          // console.log('langs', langs);
          // if (langs) {
          //   // this.textResourceService.setLangs(langs.split(","));
          // }
        }
      },
      error: (error) => {
        console.log('error', error);
        this.isError = true;
        this.dataExchangeService.setMessageHeader('ACI Walletron');
        this.dataExchangeService.setMessageText(error);
        this.router.navigate(['/err']);
      },
      complete: () => {
      }
    });
  }

  // public getBrandImage(imageUrl: string | undefined) {
  //           console.log('getBrandImage - imageUrl', imageUrl);
  // if (imageUrl) {
  //     this.brandService.getImageByUrl(imageUrl)
  //     .subscribe({
  //       next: (response) => {
  //         const reader = new FileReader();
  //         reader.onload = () => {
  //           let brandLogoImage = reader.result as string;
  //           this.dataExchangeService.setBrandLogoImage(brandLogoImage);
  //           console.log('getBrandImage - brandLogoImage', brandLogoImage);
  //           this.isComponentReady.set(true);
  //         };
  //         reader.readAsDataURL(response);
  //       },
  //       error: (error) => {
  //         this.isError = true;
  //         this.dataExchangeService.setMessageHeader('ACI Walletron');
  //         this.dataExchangeService.setMessageText(error);
  //         this.router.navigate(['/err']);
  //       },
  //       complete: () => {
  //       }
  //     });
  //   }
  // }



}
